/* eslint-disable import/no-unused-modules */
import React, { useEffect, useState } from 'react';
import { getUser } from '../../helpers/token';
import JoinCard from '../Community/JoinCard';
import Typography from '@mui/material/Typography';

export default function MembersOnly({ hostingUrl, author }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser());
  }, []);

  if (user === undefined)
    return (
      <>
        <div className="row justify-content-center">
          <div className="col-md-6 col-10">
            {hostingUrl && (
              <div className="p-3">
                <Typography
                  gutterBottom
                  variant="body1"
                  className="pb-2 highlightLinks"
                >
                  This post was originally published on{' '}
                  <a
                    href={hostingUrl}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {author.displayName || author.username}&apos;s travel blog
                  </a>
                </Typography>
              </div>
            )}
            <JoinCard
              text={`${
                hostingUrl ? 'On TravelFeed, t' : 'T'
              }his post is only available to registered TravelFeed members. Create a free account to get access to over 31,000 travel blogs!`}
              isFullText
              isBgShade
            />
          </div>
        </div>
      </>
    );
  return <div style={{ height: 500 }} />;
}
